module.exports = __webpack_public_path__ + "img/185.15587e34.jpg";